export default __webpack_public_path__ + "static/media/yellow-marker.7b19549c.svg";